import { resolve } from 'rsvp';
import Service, { inject as service } from '@ember/service';

/**
 * Service for sh-invoice related API calls
 */
export default Service.extend({
  state: service('states/application'),
  api: service(),
  session: service(),
  shData: service(),
  activityFeedStateHybrid: service('state-manager-hybrids/activity-feed-state-manager-hybrid'),

  /**
   * @param {DS.Model|string} posting
   */
  markRecentPostingItemRead(posting) {
    const id = this.shData.getModelId(posting);
    const user = this.get('session.currentUser');

    const activityFeedItem = this.get('state.mostRecentActivityFeedItems').find((activityFeedItem) => {
      return (activityFeedItem.get('feedableId') === id) && (activityFeedItem.get('feedableType') === 'Assignment');
    });

    if (!activityFeedItem || activityFeedItem.get('readAt')) {
      return resolve();
    }

    return this.markActivityFeedItemRead(activityFeedItem, user);
  },

  /**
   * @param {Application} application
   */
  markRecentProjectItemRead(application) {
    const activityFeedItem = this.state.mostRecentActivityFeedItems.find(activityFeedItem => 
      activityFeedItem.feedableId === application.id
      && activityFeedItem.feedableType === 'Application'
    );

    return (!activityFeedItem || activityFeedItem.readAt)
      ? Promise.resolve()
      : this.markActivityFeedItemRead(activityFeedItem, this.session.currentUser);
  },

  /**
   * Mark an activity feed item as read
   *
   * @param {ActivityFeedItem} activityFeedItem
   * @param {User} userThatOwnsFeedItem     The user that owns the activity feed item
   * @return {Ember.RSVP.Promise}
   */
  markActivityFeedItemRead(activityFeedItem, userThatOwnsFeedItem) {
    return this.get('api').put(`activity-feed-items/${activityFeedItem.get('id')}/mark-read`).then(response => {
      this.get('activityFeedStateHybrid').updateActivityFeedItems();
    });
  }
});
